import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { DsrStatus } from '@getaccept/lib-shared/src/enums/dsr-status';
import { SortOrder } from '@getaccept/fried-tofu';
import type { Filter } from '../types/filter';
import { RoomsOption } from '../types/rooms-option';
import { SortingAttribute } from '../types/enums/sorting-attribute';
import type { Rooms } from '../types/rooms';

export default class RoomsConstants {
  static limit = 40;

  static navbarItems = (count?: Rooms) => {
    const publishedTotal = count?.published.totalCount;
    const draftTotal = count?.draft.totalCount;
    const unpublishedTotal = count?.unpublished.totalCount;

    return [
      {
        type: DsrStatus.Published,
        dataExternal: 'rooms-navbar-published-item',
        title: t('published'),
        count: publishedTotal?.toString(),
        longTitle: t('published') + RoomsConstants.getCount(publishedTotal),
      },
      {
        type: DsrStatus.Draft,
        dataExternal: 'rooms-navbar-draft-item',
        title: t('dr_rooms_drafts_tab'),
        count: draftTotal?.toString(),
        longTitle: t('dr_rooms_drafts_tab') + RoomsConstants.getCount(draftTotal),
      },
      {
        type: DsrStatus.Unpublished,
        dataExternal: 'rooms-navbar-unpublished-item',
        title: t('unpublished'),
        count: unpublishedTotal?.toString(),
        longTitle: t('unpublished') + RoomsConstants.getCount(unpublishedTotal),
      },
    ];
  };

  static getCount = (count: number) => (count || count === 0 ? ` (${count})` : '');

  static defaultFilter: Filter = {
    statuses: [DsrStatus.Published],
    userIds: undefined,
    orderBy: {
      sortBy: SortingAttribute.LatestActivityCreatedAt,
      sortOrder: SortOrder.Desc,
    },
    limit: RoomsConstants.limit,
    offset: 0,
    searchTerms: [],
  };

  static promptData = () => ({
    [RoomsOption.Delete]: {
      title: t('dsr_delete_room'),
      text: t('rooms_are_you_sure_you_want_to_delete_the_room'),
      action: RoomsOption.Delete,
      button: t('dsr_delete_button'),
    },
    [RoomsOption.Publish]: {
      title: t('dsr_publish_room'),
      text: t('rooms_are_you_sure_you_want_to_publish_the_room'),
      action: RoomsOption.Publish,
      button: t('dsr_publish_button'),
    },
  });

  static defaultRooms: Rooms = {
    published: {
      totalCount: 0,
      rooms: [],
    },
    draft: {
      totalCount: 0,
      rooms: [],
    },
    unpublished: {
      totalCount: 0,
      rooms: [],
    },
  };
}
